<div class="container">
  <h2 class="title">{{ 'COMPANY.GCG.CORPORATE_MANAGEMENT' | translate }}</h2>
  <div class="division" *ngFor="let division of divisions">
    <h3 class="division-title">{{ division.division_name | translate }}</h3>
    <div class="row">
      <div class="col-sm-6 col-md-4" *ngFor="let member of division.members">
        <div class="member-wrapper">
          <div class="img-wrapper member-image" *ngIf="member.profile_picture">
            <img src="assets/img/{{ member.profile_picture }}" />
          </div>
          <ng-container *ngIf="member.profile_picture != undefined">
            <p class="member-name text-center">{{ member.name }}</p>
            <p class="member-position text-center">{{ member.position | translate }}</p>  
          </ng-container>
          <ng-container *ngIf="member.profile_picture == undefined">
            <p class="member-position">{{ member.position | translate }}</p>  
            <p class="member-name">{{ member.name }}</p>
          </ng-container>
        </div>
      </div>
      <div class="col-12 col-md-7" *ngIf="division.documents">
        <div class="document-wrapper" *ngFor="let document of division.documents">
          <a class="document" href="assets/docs/{{document.url}}">
            <img src="assets/img/icon_documentation.svg" />
            {{ 'COMPANY.GCG.DOWNLOAD' | translate }} {{ document.name | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>
</div>